// =============================================================
// Bootstrap de impersonation (T4).
//
// Detecta o JWT impersonado vindo do Phada Admin via URL hash:
//   http://localhost:3000/inicio/dashboard#imp_token=eyJ...
//
// O Phada Admin (suporte.phada.com.br) abre o app cliente em nova aba
// passando o JWT no hash. Aqui no boot:
//   1. Le o hash
//   2. Salva o token em localStorage.sessionToken (substitui o admin token)
//   3. Marca flag sessionImpersonating=true
//   4. Decodifica claims do JWT para guardar meta (cliente alvo, expira_em)
//   5. Remove o hash da URL (evita compartilhar token via copy/paste)
//   6. Redireciona pra raiz (forca rerender com novo token)
//
// Como esta no boot (antes do React montar), funciona com qualquer rota.
// =============================================================

const SK_ACTIVE_TOKEN = 'sessionToken';
const SK_IMP_FLAG = 'sessionImpersonating';
const SK_IMP_META = 'sessionImpersonationMeta';
const SK_IS_LOGGED = 'isLogged';

function decodeJwtPayload(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    // base64url -> base64
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

/**
 * Chamar UMA vez no boot do app (em index.js antes de createRoot).
 * Se detectar token no hash, configura tudo e retorna true.
 * Caso contrario, retorna false e segue fluxo normal.
 */
export function bootstrapImpersonation() {
  const hash = window.location.hash || '';
  const match = hash.match(/#?imp_token=([^&]+)/);
  if (!match) return false;

  const token = decodeURIComponent(match[1]);
  const claims = decodeJwtPayload(token);
  if (!claims) {
    // eslint-disable-next-line no-console
    console.warn('[impersonation] hash continha imp_token mas JWT invalido');
    return false;
  }

  // Salva o token impersonado como sessionToken (axios interceptor vai usar)
  localStorage.setItem(SK_ACTIVE_TOKEN, token);
  localStorage.setItem(SK_IS_LOGGED, 'true');
  localStorage.setItem(SK_IMP_FLAG, 'true');

  // Popula campos de sessao que o app espera. Sem isso, varios componentes
  // (Header, dashboards) podem quebrar ou redirecionar pra login.
  //   - id = ID_USUARIO do JWT (no impersonado = idadmin_original)
  //   - codidcliente = idcliente alvo
  //   - loja = idloja alvo
  //   - nome/email/tipo = placeholders identificaveis (Admin Phada)
  localStorage.setItem('sessionId', String(claims.id || claims.ID_USUARIO || 0));
  localStorage.setItem('sessionCodidcliente', String(claims.idcliente || 0));
  localStorage.setItem('sessionloja', String(claims.idloja || 0));
  localStorage.setItem('sessionEmail', 'admin@phada.com.br');
  localStorage.setItem('sessionNome', 'Admin Phada (impersonando)');
  localStorage.setItem('sessionTipoUsuario', 'admin');

  localStorage.setItem(
    SK_IMP_META,
    JSON.stringify({
      idimp_log: claims.idimp_log || 0,
      idcliente_alvo: claims.idcliente || 0,
      idloja_alvo: claims.idloja || 0,
      motivo: '(via Phada Admin)',
      iniciado_em: new Date((claims.iat || Date.now() / 1000) * 1000).toISOString(),
      expira_em: new Date(claims.exp * 1000).toISOString(),
    }),
  );

  // Remove o hash da URL pra nao vazar o token
  const cleanUrl = window.location.pathname + window.location.search;
  window.history.replaceState({}, '', cleanUrl);

  // eslint-disable-next-line no-console
  console.info('[impersonation] sessao ativada via Phada Admin');
  return true;
}

export default { bootstrapImpersonation };
